/* eslint-disable */
import '../vendor/iframeResizer.min';
import "../vendor/owl-carousel/owl.carousel.min.css";
import "../vendor/owl-carousel/owl.theme.default.min.css";
import GetMobileOperatingSystem from "../js/global/mobile-operating-system";
require(['../vendor/iframeResizer.min.js']);

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

let owl_carousel = require('owl.carousel');
window.fn = owl_carousel;


var ran = false;
var mobileOS = GetMobileOperatingSystem();

var defaultOwlCarousel = '';

var windowWidth = $(window).width();

var globalAssetPath = '';

function initOrnish(assetPath) {
    globalAssetPath = assetPath;
    updateBackgroundImages();
    cloneOwlCarousel();
    initOwlCarousel();
    initIFrameResizer();
}

function cloneOwlCarousel() {
  defaultOwlCarousel = $('.testimonials .callouts.owl-carousel').clone();
}

function initOwlCarousel() {
    mobileOS = GetMobileOperatingSystem();
    
    //if (mobileOS !== 'unknown') {
        $('.testimonials .callouts.owl-carousel').owlCarousel({
          loop:true,
          nav:true,
          dots: false,
          items: 1,
          navText: '',
          autoHeight: true,
          startPosition: 1,
          responsiveClass:true,
          responsive: {
              1025: {
                stagePadding: 270,
                margin: 0,
                center: true
              },
              1100: {
                stagePadding: 300,
                margin: 0,
                center: true 
              },
              1150: {
                stagePadding: 350,
                margin: 0,
                center: true
              },
              1250: {
                stagePadding: 400,
                margin: 0,
                center: true
              }
          },

        });
    /* }else{
      $('.testimonials .callouts.owl-carousel').owlCarousel('destroy');
   } */

   $( '.callouts-filter' ).on( 'click', 'a', function(e) {
      e.preventDefault();
      var $item = $(this);
      var filter = $item.data( 'owl-filter' );
      owlcarousel2_filter(filter, $(this));

    });
    

   
}

function initIFrameResizer() {
    //detect Internet Explorer
    var isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g)

     const myIframe = document.querySelector('.join-the-movement iframe');
     //if(isIE) {
         //alert("IE");

        /*  setTimeout(function() {
            iFrameResize({
                log:false,
                checkOrigin:false,
                //bodyMargin:'0 0 50px 0',
                bodyPadding:'0 0 150px 0',
               }, myIframe);
         },2000) */
        
     //}
     //else {
        iFrameResize({
            log:false,
            checkOrigin:false,
            //bodyMargin:'0 0 50px 0',
            bodyPadding:'0 0 80px 0',
           }, myIframe);
     //}
     

}

function owlcarousel2_filter(filter, e) {
  $('.testimonials .callouts.owl-carousel').owlCarousel('destroy');
  var carouselContainer = $('.testimonials .callouts.owl-carousel');
  var dataFilter = $('.callouts-filter');
  if(filter === 'all') {
    carouselContainer.empty().append(defaultOwlCarousel[0].innerHTML);
    
  } 
  else {
    var getClone = defaultOwlCarousel.children("."+filter).clone();
    carouselContainer.empty().append(getClone);
  }
  dataFilter.find('a').removeClass('active');
  e.addClass('active');
  initOwlCarousel();
}

function updateBackgroundImages() {
  var elemBG, elemBGName, elemBGStyleName, splitString, endOfUrl, newEndOfUrl = '';
  windowWidth = $(window).width();
  elemBG = $('.quote, .featured-header-bg');
  elemBG.each(function(index) {
      if($(this).attr('data-bg') !== undefined) {
          elemBGName, splitString, endOfUrl = '';
          elemBGName = $(this).attr('data-bg');
          splitString = elemBGName.split('/');
          endOfUrl = splitString[(splitString.length) - 1];

          if($(this).attr('style') !== undefined) {
              elemBGStyleName = $(this).attr('style');
              splitString = elemBGStyleName.split('/');
              endOfUrl = splitString[(splitString.length) - 1];
              endOfUrl = endOfUrl.replace('");', '');
          }

          if(windowWidth > 1024) {
              if(endOfUrl !== '') {
                  switch (endOfUrl) {
                      case 'quote-bg-mobile.png':
                          if($(this).attr('style') !== undefined) {
                              elemBGStyleName = elemBGStyleName.replace('-mobile', '-desktop');
                              $(this).attr('style', elemBGStyleName);
                          }
                          elemBGName = elemBGName.replace('-mobile', '-desktop');
                          $(this).attr('data-bg', elemBGName);
                          break;
                      case 'mobile-header-bg.png':
                          if($(this).attr('style') !== undefined) {
                              elemBGStyleName = elemBGStyleName.replace('mobile-', '').replace('.png', '.jpg');
                              $(this).attr('style', elemBGStyleName);
                          }
                          elemBGName = elemBGName.replace('mobile-', '').replace('.png', '.jpg');
                          $(this).attr('data-bg', elemBGName);
                          break;
                      default:
                          break;
                  }
              }
          }
          else {
              if(endOfUrl != '') {
                  switch (endOfUrl) {
                      case 'quote-bg-desktop.png':
                          if($(this).attr('style') !== undefined) {
                              elemBGStyleName = elemBGStyleName.replace('quote-bg-desktop.png', 'quote-bg-mobile.png');
                              $(this).attr('style', elemBGStyleName);
                          }
                          elemBGName = elemBGName.replace('quote-bg-desktop.png', 'quote-bg-mobile.png');
                          $(this).attr('data-bg', elemBGName);
                          break;
                      case 'header-bg.jpg':
                          if($(this).attr('style') !== undefined) {
                              elemBGStyleName = elemBGStyleName.replace('header-bg.jpg', 'mobile-header-bg.png');
                              $(this).attr('style', elemBGStyleName);
                          }
                          elemBGName = elemBGName.replace('header-bg.jpg', 'mobile-header-bg.png');
                          $(this).attr('data-bg', elemBGName);
                          break;
                      default:
                          break;
                  }
              }
          }
      }
  });
}

/* function updateBackgroundImages() {
  windowWidth = $(window).width();
  var elemBG, elemBGName, splitString, endOfUrl, newEndOfUrl = '';
    elemBG = $('.quote');
    if(elemBG.attr('style') !== undefined) {
        elemBGName = elemBG.attr('style');
        splitString = elemBGName.split('/');
        endOfUrl = splitString[(splitString.length) - 1];
        endOfUrl = endOfUrl.replace('");', '');

        if(windowWidth > 1024) {
            if(endOfUrl === 'quote-bg-mobile.png') {
                elemBGName = elemBGName.replace('-mobile', '-desktop');
                elemBG.attr('style', elemBGName);
            }
        }
        else {
            if(endOfUrl !== 'quote-bg-mobile.png' ) {
                elemBGName = elemBGName.replace('quote-bg-desktop.png', 'quote-bg-mobile.png');
                elemBG.attr('style', elemBGName);
            }

        }
    }


    elemBG = $('.featured-header-bg');
    if(elemBG.attr('style') !== undefined) {
        elemBGName = elemBG.attr('style');
        splitString = elemBGName.split('/');
        endOfUrl = splitString[(splitString.length) - 1];
        endOfUrl = endOfUrl.replace('");', '');

        if(windowWidth > 1024) {
          if(endOfUrl === 'mobile-header-bg.png') {
              //elemBGName = elemBGName.replace('-mobile', '').replace('.png', 'jpg');
              elemBGName = elemBGName.replace('mobile-header-bg.png', 'header-bg.jpg');
              elemBG.attr('style', elemBGName);
          }
      }
      else {
          if(endOfUrl !== 'mobile-header-bg.png' ) {
              elemBGName = elemBGName.replace('header-bg.jpg', 'mobile-header-bg.png');
              elemBG.attr('style', elemBGName);
          }

      }
    }
    
} */

//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        var classes = (e.target.classList);
        if(classes.contains('quote')) {
            if(windowWidth > 1024) {
                bg = bg.replace('-mobile', '-desktop');
            }
        }
        e.target.style.backgroundImage = 'url(' + bg + ')';

    }
});

$(window).resize(function() {
    updateBackgroundImages();
});


export default initOrnish;